// src/debug/googleDebug.ts
type FetchInput = Request | string | URL;

export const GDEBUG = (() => {
  // Actívalo con localStorage.setItem('gdebug','1') o ?gdebug=1
  const enabled =
    typeof window !== 'undefined' &&
    (localStorage.getItem('gdebug') === '1' ||
      new URLSearchParams(window.location.search).get('gdebug') === '1');

  const tag = (m: string) => `%c[GoogleDebug] ${m}`;
  const css = 'color:#0b87ff;font-weight:600';

  const log = (...a: any[]) => enabled && console.log(tag(''), css, ...a);
  const warn = (...a: any[]) => enabled && console.warn(tag('WARN'), css, ...a);
  const error = (...a: any[]) => enabled && console.error(tag('ERROR'), css, ...a);
  const group = (t: string) => enabled && console.groupCollapsed(tag(t), css);
  const groupEnd = () => enabled && console.groupEnd();
  const time = (label: string) => enabled && console.time(`[GoogleDebug] ${label}`);
  const timeEnd = (label: string) => enabled && console.timeEnd(`[GoogleDebug] ${label}`);

  /** Normaliza a Request|string porque en algunos TS RequestInfo no incluye URL */
  const toRequestInfo = (input: FetchInput): Request | string =>
    typeof input === 'string' ? input : (input instanceof URL ? input.toString() : input);

  // Wrapper de fetch para loguear request/response
  async function fetchWrap(input: FetchInput, init?: RequestInit) {
    const req = toRequestInfo(input);

    if (!enabled) return fetch(req as Request | string, init);

    const id = Math.random().toString(36).slice(2, 8);
    group(`fetch#${id} → ${typeof req === 'string' ? req : '[Request]'}`);
    log('init:', init);
    try {
      const res = await fetch(req as Request | string, init);
      log('status:', res.status, res.statusText);
      // Clonamos para poder leer sin consumir
      const clone = res.clone();
      const ctype = clone.headers.get('content-type') || '';
      if (ctype.includes('application/json')) {
        const json = await clone.json();
        log('body:', json);
      } else {
        const text = await clone.text();
        log('body(text):', text.slice(0, 800));
      }
      groupEnd();
      return res;
    } catch (e) {
      error('fetch error:', e);
      groupEnd();
      throw e;
    }
  }

  // Comprueba el access_token en tokeninfo (útil para ver aud/scopes/exp)
  async function checkTokenInfo(accessToken?: string | null) {
    if (!enabled || !accessToken) return;
    try {
      const url = `https://oauth2.googleapis.com/tokeninfo?access_token=${accessToken}`;
      const r = await fetch(url);
      const j = await r.json();
      group('tokeninfo');
      log(j);
      groupEnd();
      if ((j as any).aud) log('aud (client_id):', (j as any).aud);
      if ((j as any).scope) log('scopes en token:', (j as any).scope);
      if ((j as any).expires_in) log('expira en (s):', (j as any).expires_in);
    } catch (e) {
      warn('No se pudo leer tokeninfo:', e);
    }
  }

  return { enabled, log, warn, error, group, groupEnd, time, timeEnd, fetchWrap, checkTokenInfo };
})();
